module.exports = __webpack_public_path__ + "src/img/normalIconOn.39408ec4.svg";